import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

import type { ProsperContentView } from '../molecules/ProsperContent';

export const useAgentContext = ({
  searchTerm,
  selectedCategories,
  filteredCompetencyNames,
  pageView,
}: {
  searchTerm?: string;
  selectedCategories: string[];
  filteredCompetencyNames: string[];
  pageView: ProsperContentView;
}) => {
  useRegisterAgentContext({
    kind: 'list',
    description: 'Filtered competency results based on search and category selection',
    data: {
      searchTerm: searchTerm || null,
      selectedCategories: selectedCategories.length > 0 ? selectedCategories : null,
      filteredCount: filteredCompetencyNames.length,
      competencies: filteredCompetencyNames,
      viewMode: pageView,
    },
  });
};
